// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';

const PageHeader = ({
  isLoading,
  name,
}) => (
  <div className="page_title icon_plus" style={{ fontWeight: 'bold' }}>
    <div>
      <div>
        <h6 style={{ fontWeight: 'bold' }}>
          {
            `${
              // eslint-disable-next-line no-nested-ternary
              isLoading
                ? 'Create And Edit'
                : name
                  ? 'Edit'
                  : 'Create'
            } Work Order Template`
          }
        </h6>
        {
          name
            ? `Name - ${name}`
            : ''
        }
      </div>
    </div>
  </div>
);

export default PageHeader;
